import script from "./expressAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./expressAccount.vue?vue&type=script&setup=true&lang=js"

import "./expressAccount.vue?vue&type=style&index=0&id=05d08b5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d08b5a"]])

export default __exports__